'use client';
import { useState, useEffect, useRef } from 'react';
import { AxiosInstance } from '../utils';

import Slider from "react-slick";
import Spinner from '../Spinner';

function PartnerSection({ eventInfo }: any) {
    const [loading, setLoading] = useState(true);
    const [tabses, setTabses] = useState([] as any);
    const [tabsesbycat, setTabsesbycat] = useState({} as any);
    let temptabs: any[] = [];
    let temptabsbycat: any = {};
    var settings = {
        slidesToShow: 6,
        slck: true,
        slidesToScroll: 1,
        autoplay: true,
        dots: false,
        arrows: true,
        autoplaySpeed: 2000,
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 5,
                    slidesToScroll: 1,
                    infinite: true,
                    dots: false
                }
            },
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    arrows: false
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    arrows: false
                }
            },
            {
                breakpoint: 576,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    arrows: false
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: false
                }
            }]
    };
    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            temptabsbycat = {};
            try {
                const { data: response } = await AxiosInstance.get('/api/getpartners?eventcode=' + eventInfo.eventcode);
                if (response.result != "Success" || response.data?.length == 0) {
                    setLoading(false);
                    return;
                }
                for (let i = 0; i < response.data.length; i++) {

                    Object.keys(response.data[i]).forEach(key => {

                        //
                        let tmpObj = response.data[i][key];

                        if (!temptabsbycat[tmpObj.category])
                        {
                            temptabsbycat[tmpObj.category] = [];
                        }
                        
                       var ttap = temptabsbycat[tmpObj.category];

                       ttap.push(<>
                           
                            
                                <li><a target="_blank" href={tmpObj.website} title={tmpObj.name}><img style={{maxWidth:"250px", maxHeight:"150px"}} src={tmpObj.imageurl} alt={tmpObj.name} /></a></li>
                          
                        </>);

                    });

                }
            } catch (error) {
                console.error(error);
            }
            Object.keys(temptabsbycat).forEach(key => {
                temptabs.push(<>
                <div className="row pb-5">
            <div className="col-lg-12">
                   <ul className="sponsor-social-line list-inline">
                        {temptabsbycat[key]}
</ul>
                        </div>
                        </div>
                </>);
            });
            setTabses(temptabs);
            setLoading(false);
        }
        fetchData();


        return () => {
        }

    }, []);
    return (
        <section className="sec-padding" id="sponsor" data-scroll-index="7">

            <div className="container">
                <div className="sec-title">
                    <span className="icon-inner wow flipInY" data-wow-duration="300ms"><span className="fa-stack"><i className="fa rhex fa-stack-2x"></i><i className="fa fa-money fa-stack-1x"></i></span></span>
                    <h3 className="wow fadeInRight" data-wow-duration="500ms">Community Partners <small>/ Valued Partnerships</small></h3>
                </div> {/* <!--sec-title end--> */}


                <div className="partner-sec">
                   {loading?( <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '200px' }}>
                   <Spinner  size="medium"/>
                   </div>):tabses}
                    <div className="spons-dv text-center">
                        <a href="#contact" title="" data-scroll-nav="9" className="btn-default"><i className="fa fa-thumbs-up"></i> become a partner</a>
                    </div> {/* <!--spons-dv end--> */}
                </div> {/* <!--partner-sec end--> */}
            </div>
        </section>
    )
};
export { PartnerSection };